<template lang="pug">
.project-item__container.row-container
  .col-container
    div
      p.project-item__date {{ year }}
      h1.project-item__title {{ title }}
      p.project-item__subtitle {{ subtitle }}
    template(v-if="!isFinished")
      .project-item__not-ready
        LoadingSpinner.loading-spinner
        h1.project-item__not-ready-title Кейс в разработке
    template(v-else)
      img.project-item__head-img(
        :src="imgSrc"
        :alt="promo_image.title")
      a(@click.prevent).down-btn
        img(src="~assets/images/svg/icons/go_down.svg")
      .project-item__body.row-container
        .col-container.col-10
          ContentParser(:content="content")
          BaseFooter(:formValue="footer_data")
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useMediaQuery } from '@vueuse/core'
import { usePortfolioStore } from '~~/stores/portfolio'
import { small } from '~/helpers/breakpoints'

const isBreakpointMedium = reactive({})

const route = useRoute()
const page_slug = route.params.slug

const portfolioStore = usePortfolioStore()
await portfolioStore.setSlugPage(page_slug)
const { title, subtitle, content, year, promo_image, promo_image_miniature, footer_data, isFinished, meta, og } = storeToRefs(portfolioStore)
usePageHeadMeta(meta.value.title, meta.value.description, og.value)

const { $getImgUrl } = useNuxtApp()

const imgSrc = computed(() => {
  if (isBreakpointMedium.value !== undefined && isBreakpointMedium.value) {
    return promo_image_miniature.value.meta ? $getImgUrl.origin(promo_image_miniature.value.meta.download_url) : ''
  } else if (isBreakpointMedium.value !== undefined) {
    return promo_image.value.meta ? $getImgUrl.origin(promo_image.value.meta.download_url) : ''
  }
  else {
    return ''
  }
})

onMounted(() => {
  isBreakpointMedium.value = useMediaQuery(small)
})
</script>


<style lang="scss" scoped>
.container {
  max-width: 1440px;
  width: 100%;
  padding: 90px 20px 20px;
  position: relative;

  @include mobile {
    position: absolute;
    margin-top: 50px;
  }

  @include l-desktop {
    padding: 170px 123px 80px;
  }

  @include notebook {
    max-width: 1024px;
    padding: 160px 0 80px;
  }
}

.project-item {

  &__container {
    position: relative;

    @media (min-width: 1024px) and (max-width: 1279px) {
      // padding-left: 5vw;
      // padding-right: 5vw;
    }

    @media only screen and (width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
      padding-left: 10vw;
      padding-right: 10vw;
    }
  }

  &__date {
    color: $primary;
    margin-bottom: 14px;
  }

  &__title {
    color: $primary;
    margin-bottom: 16px;
  }

  &__subtitle {
    margin-bottom: 40px;
    color: $primary;
  }

  &__not-ready {
    width: 100%;
    height: 170px;
    background-color: $primary;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (min-width: $breakpoint-small) {
      height: 300px;
    }

    @media (min-width: $breakpoint-large) {
      height: 510px;
    }
  }

  &__not-ready-title {
    color: #fff;
    margin-top: 40px;
  }

  &__head-img {
    margin-bottom: 50px;
    width: 100%;
    object-fit: cover;
    min-height: 230px;

    @media (min-width: $breakpoint-medium) {
      height: auto;
      margin-bottom: 100px;
      min-height: 265px;
    }
  }

  &__body {
    display: flex;
    justify-content: center;
  }

  &__component {
    padding-top: 160px;

    @include mobile {
      padding-top: 0;
    }
  }
}

.down-btn {
  display: none;
  margin: 20px auto;
  text-align: center;
}
</style>
